import { api } from "./urlApi";

export const generarID = async () => {
  const url = `${api}/generarID.php`;

  try {
    const resp = await fetch(url);
    const id = await resp.json();
    return id.token;
  } catch (error) {
    console.error("Error: ", error);
    return false;
  }
};
